// extracted by mini-css-extract-plugin
export default {"lock":"Lock_lock__Hhy0o"};